import { notification } from "antd"
import { AxiosError } from "axios"
import { useMutation, useQuery, useQueryClient } from "react-query"
import { applyCustomerDisplayAs, completeAccountConfig, getTenant, getTenantsListForSidebar, getTimeZones, saveTenant } from "./tenantsApi"
import { TenantUpdateDTO } from "./tenantsModel"

export const useApplyCustomerDisplayAsMutation = () => {
  return useMutation({
    mutationFn: () => applyCustomerDisplayAs(),
    onError: () => {
      notification.error({ message: 'There was an error applying the customer display as. Please try again later.' })
    }
  })
}

export const useTenantsQuery = (tenantId: number | undefined) => {
  return useQuery(['tenant', tenantId ?? 0], {
    queryFn: () => getTenant(tenantId),
    enabled: !!tenantId,
    refetchOnWindowFocus: false
  })
} 

export const useSidebarTenantsQuery = () => {
  return useQuery(['sidebarTenants'], {
    queryFn: () => getTenantsListForSidebar(),
    refetchOnWindowFocus: false
  })
}

export const useTenantTimeZonesQuery = () => {
  return useQuery(['timeZones'], {
    queryFn: () => getTimeZones(),
    refetchOnWindowFocus: false
  })
}

export const useSaveTenantMutation = (onSuccess?: (tenantId: number) => void) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (tenant: TenantUpdateDTO) => saveTenant(tenant),
    onSuccess: (data) => {
      queryClient.invalidateQueries(['sidebarTenants'])
      queryClient.invalidateQueries(['tenant', data.id])

      onSuccess?.(data.id)
    },
    onError: (error: AxiosError) => {
      const errorMessage = error.response?.data as string;

      notification.error({
        message: errorMessage,
      })
    }
  })
}

export const useCompleteAccountConfigMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (tenantId: number) => completeAccountConfig(tenantId),
    onSuccess: () => {
      queryClient.invalidateQueries(['account'])
    }
  })
}